import { IntlProvider } from 'react-intl';

import { i18n } from '../i18n/config';
import { getDictionary } from '../i18n/dictionaries';

import type { Locale } from '../i18n/config';

type Props = {
  children: React.ReactNode;
  locale: Locale;
};

export default function ReactIntl({ children, locale = i18n.defaultLocale }: Props) {
  const localMessages = getDictionary(locale);

  return (
    <IntlProvider key={locale} locale={locale} messages={localMessages}>
      {children}
    </IntlProvider>
  );
}
